import updateConfigSettings from '../../../actions/siteadmin/SiteSettings/updateConfigSettings';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
   const isRestrict = await dispatch(demoRestriction({}));
   if (isRestrict) return;
  dispatch(updateConfigSettings(values));
}

export default submit;
